// src/components/strumenti/ScontiCascata.js — W442. Sconti in serie (es. 50+10+5) e sconto equivalente
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, Avviso, euro, fmt } from "./UiStrumento";
import { scontiDaTesto, scontiACascata } from "../../utils/calcoliStrumenti";

export default function ScontiCascata() {
  const { v, set, n, azzera } = useCampi({ prezzo:"", sconti:"" });
  const lista = v.sconti.trim() ? scontiDaTesto(v.sconti) : null;
  const r = lista ? scontiACascata(n("prezzo"), lista) : null;
  const errore = v.sconti.trim() && (!lista || lista.some(s => s < 0 || s > 100));
  return (
    <div>
      <Griglia colonne={2}>
        <Campo etichetta="Prezzo di listino (€)" valore={v.prezzo} onChange={set("prezzo")} placeholder="Es. 1000"/>
        <Campo etichetta="Sconti in serie (%)" valore={v.sconti} onChange={set("sconti")} placeholder="Es. 50+10+5" aiuto="Separati da «+», come nei listini."/>
      </Griglia>
      {errore && <Avviso>Scrivi gli sconti come numeri tra 0 e 100 separati da «+» (es. 50+10+5).</Avviso>}
      <Risultato settore="amministrativo" titolo="Prezzo netto" valore={euro(r?.netto)}
        righe={r ? [["Sconto equivalente unico", fmt(r.scontoEquivalente, 4) + "%"], ["Risparmio", euro(r.risparmio)], ...r.passi.map((p, i) => [`${i + 1}° sconto ${fmt(p.sconto)}%`, `${euro(p.prima)} → ${euro(p.dopo)}`])] : []}/>
      <Formula>Netto = listino × (1 − s₁) × (1 − s₂) × … Gli sconti si applicano uno dopo l'altro, quindi non si sommano: 50+10+5 equivale al 57,25%, non al 65%. Sconto equivalente = 1 − netto ÷ listino.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
